module.exports = __webpack_public_path__ + "static/img/8.6f11977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/8.png
// module id = XiyF
// module chunks = 0